import {
  DragSource,
  DragSourceConnector,
  DragSourceMonitor,
  DropTarget,
  DropTargetConnector,
  DropTargetMonitor,
} from "react-dnd";
import { DraggableInstance, DragItem, shouldMove } from "utils/dndUtils";
import DraggableSkuRule, { DraggableSkuRuleProps } from "./DraggableSkuRule";

const EnabledDraggableSkuRule = DropTarget(
  "SKU_RULE",
  {
    drop({ onDropSkuRule }: DraggableSkuRuleProps) {
      onDropSkuRule();
    },
    hover(
      { index, onMoveSkuRule }: DraggableSkuRuleProps,
      monitor: DropTargetMonitor,
      component: DraggableInstance
    ) {
      if (!monitor.canDrop()) {
        return null;
      }

      if (!component) {
        return null;
      }

      // node = HTML Div element from imperative API
      const node = component.getNode();
      if (!node) {
        return null;
      }

      const item = monitor.getItem<DragItem>();
      const dragIndex = item.index;
      const hoverIndex = index;

      if (shouldMove(hoverIndex, node, dragIndex, monitor)) {
        onMoveSkuRule(item.index, index);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        item.index = hoverIndex;
      }
    },
    canDrop({ readonly }: DraggableSkuRuleProps) {
      return !readonly;
    },
  },
  (connect: DropTargetConnector) => ({
    connectDropTarget: connect.dropTarget(),
  })
)(
  DragSource(
    "SKU_RULE",
    {
      beginDrag: ({ skuRule, index }: DraggableSkuRuleProps) => ({
        id: skuRule.id,
        index,
      }),
    },
    (connect: DragSourceConnector, monitor: DragSourceMonitor) => ({
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview(),
      isDragging: monitor.isDragging(),
    })
  )(DraggableSkuRule)
);

export default EnabledDraggableSkuRule;
